/**
 * 유틸리티 함수 모음
 *
 * @module lib/utils
 */

// cn 함수 (클래스명 병합 유틸리티)
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export * from './audioUtils';
export * from './statusUtils';
export * from './download';
export * from './formatUtils';
export * from './idUtils';
export * from './errorUtils';
export * from './logger';
export * from './typeUtils';
export * from './referenceSongUtils';
